import "./MainSection.css"



export const MainSection = ({children}) => {


    return(
        <main>
            <div>{children}</div>
        </main>
    )



}